// Components/CreateNews/CreateNews.js

import React, { useState, useEffect, useCallback, useMemo } from "react";
import * as S from "./CreateNewsStyle";
import { newsService } from "../../Services/newsService";
import {
  FaPlus,
  FaTimes,
  FaTrash,
  FaEdit,
  FaCheck,
  FaBan,
} from "react-icons/fa";
import Loading from "../Loader";

// O ModalComponent permanece o mesmo da versão anterior, então o mantemos aqui.
function ModalComponent({ onClose, onSave, onUpdate, newsToEdit }) {
  const [mideaUrl, setMideaUrl] = useState("");
  const [title, setTitle] = useState("");
  const [text, setText] = useState("");
  const [link, setLink] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (newsToEdit) {
      setTitle(newsToEdit.title);
      setText(newsToEdit.text);
      setLink(newsToEdit.link || "");
      setMideaUrl(newsToEdit.mideaUrl || "");
    } else {
      setTitle("");
      setText("");
      setLink("");
      setMideaUrl("");
    }
  }, [newsToEdit]);

  const handleSave = async () => {
    if (!mideaUrl || !title || !text) {
      return alert("URL da Imagem, Título e Texto são obrigatórios!");
    }
    setLoading(true);
    try {
      const newsData = { title, text, mideaUrl, link: link || null };
      if (newsToEdit) {
        await onUpdate(newsToEdit.id, newsData);
      } else {
        await onSave(newsData);
      }
    } catch (error) {
      console.error("Erro ao salvar notícia:", error);
      alert("Erro ao salvar notícia.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <S.ModalOverlay>
      <S.ModalContent>
        <Loading load={loading} />
        <S.ModalHeader>
          <h3>{newsToEdit ? "Editar Notícia" : "Criar Nova Notícia"}</h3>
          <S.CloseButton onClick={onClose}>
            <FaTimes />
          </S.CloseButton>
        </S.ModalHeader>
        <S.ModalBody>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <S.InputGroup>
              <label>URL da Imagem</label>
              <input
                type="text"
                value={mideaUrl}
                placeholder="https://exemplo.com/imagem.jpg"
                onChange={(e) => setMideaUrl(e.target.value)}
              />
            </S.InputGroup>
            {mideaUrl && (
              <S.ImagePreview
                src={mideaUrl}
                alt="Preview"
                onError={(e) => (e.target.style.display = "none")}
                onLoad={(e) => (e.target.style.display = "block")}
              />
            )}
            <S.InputGroup>
              <label>Título da Notícia</label>
              <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </S.InputGroup>
            <S.InputGroup>
              <label>Texto da Notícia</label>
              <textarea
                value={text}
                onChange={(e) => setText(e.target.value)}
              />
            </S.InputGroup>
            <S.InputGroup>
              <label>Link de Redirecionamento (Opcional)</label>
              <input
                type="text"
                value={link}
                placeholder="https://exemplo.com/noticia-completa"
                onChange={(e) => setLink(e.target.value)}
              />
            </S.InputGroup>
          </div>
        </S.ModalBody>
        <S.ModalFooter>
          <S.SendButton onClick={handleSave}>
            {newsToEdit ? "Salvar Alterações" : "Enviar para Aprovação"}
          </S.SendButton>
        </S.ModalFooter>
      </S.ModalContent>
    </S.ModalOverlay>
  );
}

export default function CreateNews() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [allNews, setAllNews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingNews, setEditingNews] = useState(null);
  const [activeTab, setActiveTab] = useState(newsService.NewsStatus.PENDENTE);

  const getNews = useCallback(async () => {
    setLoading(true);
    try {
      const data = await newsService.getAllNews();
      setAllNews(data);
    } catch (error) {
      console.error("Erro ao buscar notícias:", error);
      alert("Não foi possível carregar as notícias.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getNews();
  }, [getNews]);

  // Filtra as notícias com base na aba ativa
  const filteredNews = useMemo(() => {
    return allNews.filter((n) => n.status === activeTab);
  }, [allNews, activeTab]);

  const handleCreateNews = async (newsData) => {
    await newsService.createNews(newsData);
    alert("Notícia enviada para aprovação!");
    closeModal();
    getNews();
  };

  const handleUpdateNews = async (id, newsData) => {
    await newsService.updateNews(id, newsData);
    alert("Notícia atualizada com sucesso!");
    closeModal();
    getNews();
  };

  const handleUpdateStatus = async (id, newStatus) => {
    const confirmAction = window.confirm(
      `Tem certeza que deseja alterar o status para ${newStatus}?`
    );
    if (confirmAction) {
      try {
        await newsService.updateNewsStatus(id, newStatus);
        // Atualiza o estado local para refletir a mudança imediatamente
        setAllNews(
          allNews.map((n) => (n.id === id ? { ...n, status: newStatus } : n))
        );
        alert("Status atualizado com sucesso!");
      } catch (error) {
        alert("Erro ao atualizar status.");
      }
    }
  };

  const handleDeleteNews = async (id) => {
    if (
      window.confirm(
        "Tem certeza que deseja EXCLUIR esta notícia? Esta ação não pode ser desfeita."
      )
    ) {
      try {
        await newsService.deleteNews(id);
        setAllNews(allNews.filter((item) => item.id !== id));
        alert("Notícia excluída com sucesso!");
      } catch (error) {
        alert("Erro ao excluir notícia.");
      }
    }
  };

  const openCreateModal = () => {
    setEditingNews(null);
    setIsModalOpen(true);
  };
  const openEditModal = (newsItem) => {
    setEditingNews(newsItem);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setEditingNews(null);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Data indisponível";
    return new Date(dateString).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <S.PageContainer>
      <Loading load={loading && !isModalOpen} />
      {isModalOpen && (
        <ModalComponent
          onClose={closeModal}
          onSave={handleCreateNews}
          onUpdate={handleUpdateNews}
          newsToEdit={editingNews}
        />
      )}

      <S.ContentBox>
        <S.Header>
          <h2>Gerenciar Notícias</h2>
          <S.CreateButton onClick={openCreateModal}>
            <FaPlus /> Criar Nova Notícia
          </S.CreateButton>
        </S.Header>

        <S.TabContainer>
          <S.TabButton
            active={activeTab === "PENDENTE"}
            onClick={() => setActiveTab("PENDENTE")}
          >
            Pendentes
          </S.TabButton>
          <S.TabButton
            active={activeTab === "ATIVA"}
            onClick={() => setActiveTab("ATIVA")}
          >
            Ativas
          </S.TabButton>
          <S.TabButton
            active={activeTab === "CANCELADA"}
            onClick={() => setActiveTab("CANCELADA")}
          >
            Canceladas
          </S.TabButton>
        </S.TabContainer>

        <S.NewsList>
          {filteredNews.length > 0 ? (
            filteredNews.map((n) => (
              <S.NewsItem key={n.id}>
                <div className="info">
                  <img alt="notícia" src={n.mideaUrl} />
                  <div>
                    <p>{n.title}</p>
                    <span>Publicado em: {formatDate(n.dateCreated)}</span>
                  </div>
                </div>
                <div className="actions">
                  <S.StatusTag status={n.status}>{n.status}</S.StatusTag>
                  {n.status === "PENDENTE" && (
                    <>
                      <S.ActionButton
                        color="green"
                        onClick={() => handleUpdateStatus(n.id, "ATIVA")}
                        title="Ativar"
                      >
                        <FaCheck />
                      </S.ActionButton>
                      <S.ActionButton
                        color="orange"
                        onClick={() => handleUpdateStatus(n.id, "CANCELADA")}
                        title="Cancelar"
                      >
                        <FaBan />
                      </S.ActionButton>
                    </>
                  )}
                  {n.status === "ATIVA" && (
                    <S.ActionButton
                      color="orange"
                      onClick={() => handleUpdateStatus(n.id, "CANCELADA")}
                      title="Cancelar"
                    >
                      <FaBan />
                    </S.ActionButton>
                  )}
                  {n.status === "CANCELADA" && (
                    <S.ActionButton
                      color="green"
                      onClick={() => handleUpdateStatus(n.id, "ATIVA")}
                      title="Reativar"
                    >
                      <FaCheck />
                    </S.ActionButton>
                  )}
                  <S.EditButton
                    onClick={() => openEditModal(n)}
                    title="Editar Conteúdo"
                  >
                    <FaEdit />
                  </S.EditButton>
                  <S.DeleteButton
                    onClick={() => handleDeleteNews(n.id)}
                    title="Excluir"
                  >
                    <FaTrash />
                  </S.DeleteButton>
                </div>
              </S.NewsItem>
            ))
          ) : (
            <p
              style={{
                textAlign: "center",
                color: "#fff",
                opacity: "0.7",
                marginTop: "20px",
              }}
            >
              Nenhuma notícia nesta categoria.
            </p>
          )}
        </S.NewsList>
      </S.ContentBox>
    </S.PageContainer>
  );
}
